import React, { useState, useCallback, useEffect } from "react";
import CKEditor from "ckeditor4-react";

import { makeStyles } from "@material-ui/core/styles";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import Button from "components/CustomButtons/Button";

const useStyles = makeStyles(() => ({
  dialogActions: {
    justifyContent: "center"
  }
}));

const HelpTextEditDialog = ({ open, topic, content, onClose, onSave }) => {
  const classes = useStyles();
  const [editorData, setEditorData] = useState("");
  const [saveDisabled, setSaveDisabled] = useState(false);

  useEffect(() => {
    setEditorData(content);
    setSaveDisabled(false);
  }, [content]);

  const handleEditorChange = useCallback(evt => {
    setEditorData(evt.editor.getData());
  }, []);

  const handleSave = useCallback(() => {
    onSave(editorData);
    setSaveDisabled(true);
  }, [editorData]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit {topic} Topic Help Text</DialogTitle>
      <DialogContent>
        <CKEditor data={editorData} onChange={handleEditorChange} />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button
          color="success"
          variant="contained"
          onClick={handleSave}
          disabled={saveDisabled}
        >
          Save
        </Button>
        <Button color="danger" variant="contained" onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HelpTextEditDialog;
